var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "md-button": true,
        "md-button": true,
        "md-raised": true,
        "md-primary": true,
        "md-theme-default": true,
        "md-theme-default": true,
        "create-account-btn": true,
        "create-account-bottom-btn": _vm.isBottom
      },
      attrs: { dusk: "registration-form-create-account-bottom-button" },
      on: {
        click: function($event) {
          _vm.clicked()
        }
      }
    },
    [
      _c("div", { staticClass: "md-ripple" }, [
        _c("div", { staticClass: "md-button-content" }, [
          _vm._v("\n            " + _vm._s(_vm.label) + "\n        ")
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-035b1d47", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-035b1d47","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/button.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-035b1d47","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/button.vue
// module chunks = 1 2 3